import {
    Checkbox,
    Table,
    TableBody,
    TableHead,
    TableRow,
    Typography,
    TableCell,
    styled,
} from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormCheckbox from '../../shared/FormCheckbox';

const StyledTableCell = styled(TableCell)({
    paddingLeft: 0,
    paddingRight: 0,
});

const ChatNotifications = () => {
    const { control } = useFormContext();
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <StyledTableCell
                        sx={{ width: '70%', borderBottom: 'none', py: 0 }}
                    >
                        <Typography variant='subHeading'>
                            In-app Messaging Notifications
                        </Typography>
                    </StyledTableCell>
                    <StyledTableCell
                        padding='checkbox'
                        align='center'
                        sx={{ borderBottom: 'none' }}
                    >
                        Email
                    </StyledTableCell>
                    <StyledTableCell
                        padding='checkbox'
                        align='center'
                        sx={{ borderBottom: 'none' }}
                    >
                        Mobile
                    </StyledTableCell>
                    <StyledTableCell
                        padding='checkbox'
                        align='center'
                        sx={{ borderBottom: 'none' }}
                    >
                        In-app
                    </StyledTableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                <TableRow>
                    <StyledTableCell>
                        <Typography>New Messages</Typography>
                        Get notified about any new messages or replies.
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        <FormCheckbox
                            name='newMessageEmailNotification'
                            control={control}
                        />
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        <FormCheckbox
                            name='newMessagePushNotification'
                            control={control}
                        />
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        <Checkbox checked disabled />
                    </StyledTableCell>
                </TableRow>
                <TableRow>
                    <StyledTableCell>
                        <Typography>Reminders</Typography>
                        Get reminded about any unread messages.
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        <FormCheckbox
                            name='reminderEmailNotification'
                            control={control}
                        />
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        N/A
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        N/A
                    </StyledTableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default ChatNotifications;
